import {STATUS} from '@jobseeker/common-core/constants';
import qs from 'qs';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';
import {SurveyAnswerType} from './types';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/`
);

const getSurvey = async (pageName: string) => {
  try {
    let surveyId: number | null = null;

    if (pageName === 'JOBFEED') {
      const resp = await fetch(process.env.NEXT_PUBLIC_SURVEY_S3_URL as string);
      const surveyS3JSON = await resp.json();
      surveyId = surveyS3JSON?.survey?.survey_id ?? 8;
    }

    const url =
      pageName === 'JOBFEED'
        ? `survey?id=${surveyId}`
        : `survey?placement=${pageName}&type=unanswered`;

    const response = await axios.get(url, {withCredentials: true});

    if (response[STATUS] === 200) {
      return response?.data;
    }

    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const answerSurveyQuestion = async (answer: SurveyAnswerType) => {
  try {
    const response: any = await axios.post(
      `survey/answer`,
      qs.stringify(answer),
      {
        withCredentials: true,
      }
    );
    if (response[STATUS] === 200) {
      return response?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const parseResume = async () => {
  try {
    const response: any = await axios.get(`parse-resume`, {
      withCredentials: true,
    });
    if (response[STATUS] === 200) {
      return response?.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response.data.error.message,
        code: error.response.data.error.statusCode,
      },
    };
  }
};

const surveyService = {
  getSurvey,
  answerSurveyQuestion,
  parseResume,
};

export default surveyService;
